import { TableCellNode } from "@lexical/table";
import { findDataTableNode } from "../utils/is-in-table-node";

import type { SerializedTableCellNode } from "@lexical/table";
import type { EditorConfig, LexicalNode, NodeKey } from "lexical";

type SerializedDataTableCellNode = SerializedTableCellNode & {
  type: "data-table-cell";
  border?: string;
};

export class DataTableCellNode extends TableCellNode {
  static getType(): string {
    return "data-table-cell";
  }

  constructor(backgroundColor?: string, key?: NodeKey) {
    super(undefined, undefined, undefined, key);
    this.__backgroundColor = backgroundColor ?? null;
  }

  static clone(node: DataTableCellNode): DataTableCellNode {
    return new this(node.__backgroundColor ?? undefined, node.__key);
  }

  exportJSON(): SerializedDataTableCellNode {
    return { ...super.exportJSON(), type: "data-table-cell" };
  }

  static importJSON(serializedNode: SerializedDataTableCellNode): DataTableCellNode {
    return new this(serializedNode.backgroundColor ?? undefined).updateFromJSON(serializedNode);
  }

  createDOM(config: EditorConfig): HTMLTableCellElement {
    const dom = super.createDOM(config);
    dom.classList.add("data-table-cell");

    dom.style.backgroundColor = this.__backgroundColor ?? "transparent";
    const tableNode = findDataTableNode(this);
    if (tableNode) {
      dom.style.border = tableNode.getBorderString();
      dom.style.padding = tableNode.getCellPaddingString();
    }
    return dom;
  }

  updateDOM(): boolean {
    return true;
  }
}

export function $createDataTableCellNode(): DataTableCellNode {
  return new DataTableCellNode();
}

export function $isDataTableCellNode(
  node: LexicalNode | null | undefined,
): node is DataTableCellNode {
  return node instanceof DataTableCellNode;
}
